/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import 'jquery-confirm';
import 'jquery-confirm/dist/jquery-confirm.min.css';
import 'suneditor/dist/css/suneditor.min.css';
import 'antd/dist/antd.css';
import 'aos/dist/aos.css';

import './assets/icofont/icofont.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/default/lineicons.min.css';
import './assets/style.css';
import './assets/css/bootstrap.min.css';
import './assets/custom.css';

import App from './App';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
